import styled from 'styled-components';

export const SelectWrapper = styled.div``;

export const SelectCurrentValue = styled.div`
	padding: 7px 12px 8px;
	border: 1px solid var(--border-color-strong);
	cursor: pointer;
`;

export const SelectOptions = styled.ul`
	list-style: none;
	width: 100%;
	padding: 0;
	background: var(--background);
	margin: 0;
`;

export const SelectOption = styled.li<{ isHighlighted: boolean }>`
	padding: 7px 12px 8px;

	background-color: ${(props: { isHighlighted: boolean }) =>
		props.isHighlighted ? 'var(--orange)' : ''};
	cursor: pointer;
`;
